import { normalizeIdList } from './translationSubmit'
import { categoryIdsForSubmit } from './categoryHelpers'

/** Never compare or send these on PATCH `/tours/:id` (managed elsewhere / read-only). */
export const TOUR_PATCH_IGNORE_FIELDS = new Set([
  'contentCategories',
  'contentCategoriesByType',
  'structuredContentCategories',
  'includes',
  'excludes',
  'faqs',
  'bannerImages',
  'images',
  'education',
  'health',
  'transport',
  'facilities',
  'options',
  'themes',
  'itinerary',
  'ratings',
  'disponibilite_from',
  'disponibilite_to',
  'createdAt',
  'updatedAt',
  '__v',
  // Display-only pricing fields (Tour.price is an ObjectId relation, not a number)
  'price',
  'promoPrice',
  'id',
  '_id',
])

export function sanitizeTourPatchPayload(
  payload: Record<string, unknown>,
): Record<string, unknown> {
  const out: Record<string, unknown> = {}

  for (const [key, value] of Object.entries(payload)) {
    if (TOUR_PATCH_IGNORE_FIELDS.has(key)) {
      continue
    }

    if (key === 'published') {
      out.status = value ? 'published' : 'draft'
      continue
    }

    if (key === 'faqs' || key === 'events') {
      out[key] = normalizeIdList(value as unknown[])
      continue
    }

    if (key === 'gallery' && Array.isArray(value)) {
      out[key] = normalizeIdList(value)
      continue
    }

    if (key === 'category') {
      out[key] = categoryIdsForSubmit(value)
      continue
    }

    if (key === 'types' && Array.isArray(value)) {
      out[key] = normalizeIdList(value)
      continue
    }

    if (key === 'routeCities' && Array.isArray(value)) {
      out[key] = normalizeIdList(value)
      continue
    }

    if (key === 'banner' && value && typeof value === 'object') {
      const banner = value as { _id?: string; id?: string }
      out[key] = banner._id || banner.id || value
      continue
    }

    if (key === 'city' && value && typeof value === 'object') {
      const city = value as { _id?: string; id?: string }
      out[key] = city._id || city.id || value
      continue
    }

    if (key === 'location' && value && typeof value === 'object') {
      const location = value as { _id?: string; id?: string }
      out[key] = location._id || location.id || value
      continue
    }

    out[key] = value
  }

  return out
}
